import { z } from "zod";

import type { AppProps } from "./types.js";

export const datasetSchema = z.object({
	dataset: z.object({
		language: z.union([z.literal("EN"), z.literal("FR")]),
		links: z
			.string()
			.transform((s) => z.record(z.string(), z.string()).parse(JSON.parse(s))),
		pouches: z.string().transform((s) => z.array(z.any()).parse(JSON.parse(s))),
		rootpath: z.string(),
		translations: z
			.string()
			.transform((s) => z.record(z.string()).parse(JSON.parse(s))),
	}),
});

/**
 * Gets the required data from the page content
 *
 * @param container The app host container
 * @returns The AppProps to use
 */
export function getHTMLAppProps(container: HTMLDivElement): AppProps {
	const data = datasetSchema.parse(container);
	return {
		...data.dataset,
		languageSuffix: data.dataset.language,
		rootPath: data.dataset.rootpath,
	};
}
